import React, { useState } from 'react';
import CircleOfFifths from './components/CircleOfFifths';
import InfoPanel from './components/InfoPanel';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  const [selectedKey, setSelectedKey] = useState(null);
  const [hoveredKey, setHoveredKey] = useState(null);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-purple-900/20 via-slate-900/50 to-slate-900"></div>
      
      <div className="relative z-10">
        <Header />
        
        <main className="container mx-auto px-4 py-8">
          <div className="grid lg:grid-cols-2 gap-8 items-start">
            <div className="flex justify-center">
              <CircleOfFifths 
                selectedKey={selectedKey}
                hoveredKey={hoveredKey}
                onKeySelect={setSelectedKey}
                onKeyHover={setHoveredKey}
              />
            </div>
            
            <div className="lg:sticky lg:top-8">
              <InfoPanel 
                selectedKey={selectedKey || hoveredKey}
              />
            </div>
          </div>
        </main>
        
        <Footer />
      </div>
    </div>
  );
}

export default App;